import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "eyeOpen", "eyeSlash", "toggle"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"
    this.eyeOpenTarget.hidden = isPassword
    this.eyeSlashTarget.hidden = !isPassword
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-label", isPassword ? "Hide password" : "Show password")
    }
  }
}
